import React, { useState, useEffect } from 'react'
import { HStack, Box, Text,
    FormControl,
    InputGroup, Input, InputRightElement, useBoolean,
    Popover, FormErrorMessage,
    PopoverTrigger,
    PopoverContent,
    PopoverBody,    
    useOutsideClick,
    Avatar,
} from '@chakra-ui/react'
import dayjs from 'dayjs'
import { Icon } from '.'



const Option = ({label, value, isActive, isDisabled, avatar, onChange, ...props}) => {

    return(
        <Box 
            color={isActive ? "brand.600" : "gray.800"} 
            onClick={() => onChange(value)} 
            bg={isActive ? "accent.50" : "transparent"} 
            cursor="pointer" px="3" py="2" 
            _hover={{ bg: 'accent.50' }}
            {...isDisabled && {
                onClick: () => null,
                opacity: 0.5,
                cursor: 'not-allowed',
                _hover:{ bg: 'transparent'}
            }}
            >
            <HStack alignItems="center">
                {
                    avatar &&
                    <Avatar opacity={isDisabled ? '0.5' : '1'} size="xs" name={label} src={avatar} />
                }
                <Text flexGrow={1} my="0" color="currentcolor" fontWeight="500" fontSize="14px">{label}</Text>
                {isActive && <Icon color="currentcolor" name="md-checkmark" /> }
            </HStack>
        </Box>
    )
} 


const Select = React.forwardRef( ({children, allowNew=false, readOnly, info, multiple=false, error, placeholder, label, required, onChange, value = "" ,  ...rest}, ref) => {

    const [ current, setCurrent ] = useState(value)
    const [ innerValue, setInnerValue ] = useState('')    
    const [ show, setShow ] = useBoolean(false)    
    const [ mount, setMount] = useBoolean(false)
    const [ options, setOptions ] = useState([])
    const popupRef = React.useRef(null)
    const inputRef = React.createRef(null)

    
    useEffect(() => {
        setCurrent(value)
    }, [value])

    const handleChange = React.useCallback((val) => {
        onChange(val)
    }, [onChange])
    
    useEffect(() => {                        
        if(children?.length > 0 && !mount){               
            let opts = []   
            let cloned_opt = null 
            // React.Children?.map(children, (child, i) => {
            React.Children.forEach(children, (child, i) => {
                if(React.isValidElement(child)){
                    if(current === child?.props?.value){
                        setInnerValue(child?.props?.label)
                    }
                    cloned_opt = React.cloneElement(child, {               
                            isActive: current === child?.props?.value, 
                            value: child?.props?.value,
                            isDisabled: child?.props?.isDisabled,
                            key: i,
                            avatar: child?.props?.avatar,
                            onChange: (i) => {
                                setCurrent(child?.props?.value)                                                                
                                setInnerValue(child?.props?.label)
                                handleChange(child?.props?.value)
                                setMount.off()
                                setShow.off()
                                
                            } 
                    });                    
                }
                if(cloned_opt){
                    opts.push(cloned_opt)                
                }                
            })         
            setOptions(opts)
        }

    }, [children, setShow, current, innerValue, mount, setMount, handleChange])

    const clearVal = () => {
        setCurrent('')
        onChange('')      
        // setQ('')          
        setInnerValue('')
        setMount.off()
    }

    const onFilter = (value) => {               
        setCurrent('')
        let opts = [];        
        setMount.on()
        React.Children.forEach(children, (child, i) => {
            if(child?.props?.label?.toUpperCase().includes(value?.toUpperCase()) || value===""  ){
                let cloned_opt = React.cloneElement(child, {               
                        isActive: current === child?.props?.value, 
                        value: child?.props?.value,
                        avatar: child?.props?.avatar,
                        isDisabled: child?.props?.isDisabled,
                        key: i,
                        onChange: (i) => {                                
                            setCurrent(child?.props?.value)
                            handleChange(child?.props?.value)
                            setInnerValue(child?.props?.label) 
                            setMount.off()
                            setShow.off()
                        } 
                });
                opts.push(cloned_opt)
            }
            
        })
        setOptions(opts)
    }
    
    useOutsideClick({
        ref: popupRef,
        handler: () => {                                     
            if(!allowNew && show){
                if(!current){            
                    setInnerValue('')
                }
            }
            if(allowNew && show){
                handleChange(innerValue)
            }
            setShow.off()
            setMount.off()
        },
    })

    

    let all_options = options;
    
    // console.log("Options", innerValue)

    return(
        <Box m="0">
            <FormControl isInvalid={error}>
                {label && <Text mt={0} mb={2}  fontSize="12px" color="gray.400" fontWeight="600" textTransform="uppercase">{label} { required && <Text as="span" fontSize="sm" color="red">*</Text>}</Text>}
                {info && <Text my="0" mb="4" color="gray.500" fontSize="sm">{info}</Text> }
                <Box  ref={popupRef}>
                    <Popover initialFocusRef={inputRef} isOpen={show} matchWidth offset={0} _focus={{ shadow:'none' }}> 
                        <PopoverTrigger>                            
                            <InputGroup ref={ref} autoComplete="password">
                                <Input 
                                    autoComplete="password"                                     
                                    placeholder={placeholder} 
                                    onFocus={setShow.on}  
                                    // onClick={setShow.on}
                                    readOnly={readOnly} 
                                    name={dayjs()}
                                    value={innerValue}
                                    onChange = {(e) => {
                                        onFilter(e.target.value)
                                        setInnerValue(e.target.value)
                                        
                                    }}
                                    // {...(readOnly) ? 
                                    //     {value: innerValue || ''} : 
                                    //     { 
                                    //         value: innerValue || '', 
                                    //         onChange:(e) => {
                                    //             setInnerValue(e.target.value)                                            
                                    //             onFilter(e.target.value)
                                    //         },                                            
                                    //         onBlur:(e) => {                                                
                                    //             onChange(e.target.value)
                                    //         }
                                    //     }
                                    // }
                                    {...rest} 
                                    ref={inputRef} 
                                />
                                <InputRightElement>
                                    <HStack>                                
                                        {
                                            innerValue &&
                                            <Icon onClick={() => clearVal()}   fontSize="14px" name="close-fill" color="currentcolor" />
                                            
                                        }
                                        <Icon fontSize="18px" onClick={setShow.on} name="arrow-down-s-fill" />
                                    </HStack>
                                </InputRightElement>
                            </InputGroup>
                        </PopoverTrigger>
                        <PopoverContent w="100%" shadow="none" _focusVisible={false} _focus={{ shadow:'none' }} rounded="none">
                            <PopoverBody shadow="none" p="0">
                                
                                <Box maxH="180px" overflowY="auto">
                                    {all_options}
                                </Box>
                            </PopoverBody>
                        </PopoverContent>
                    </Popover>  
                </Box>          
                <FormErrorMessage>{error}</FormErrorMessage>                  
            </FormControl>
        </Box>        
    )
})

Select.Option = Option
export { Select }